export default "__VITE_ASSET__D$i_5PCC__"